import React from 'react';
import { PencilIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import {
  Box,
  IconButton,
  Stack,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

import DateTimeDisplay from '../../DateTimeDisplay';

const ApplicationReceivedReadOnly = ({
  data,
  toggleEditMode,
  applicationReceivedEditAllowed,
}) => {
  const tooltipTitle = applicationReceivedEditAllowed
    ? ''
    : 'Permission to edit is required.';
  return (
    <Stack direction="row" gap={1}>
      <Box marginLeft={4}>
        <DateTimeDisplay data={data} />
      </Box>
      <Tooltip title={tooltipTitle}>
        <IconButton
          size="small"
          onClick={toggleEditMode}
          color="primary"
          disabled={!applicationReceivedEditAllowed}
        >
          <PencilIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default ApplicationReceivedReadOnly;
